import * as React from "react";
import { useState } from "react";
import ToggleButton from "../commons/components/buttons/ToggleButton";
import { ModalWarning } from "../commons/components/modal/ModalWarning";

export interface PracticeQuestionOverrideFormSettings {
  editQuestions: boolean;
  practiceQuestionOverride: boolean;
  updatePracticeQuestionOverrideUrl?: string;
}

export default function SettingPracticeQuestionOverrideForm({
  practiceQuestionOverrideFormSettings,
  onChangeToggle,
}: {
  practiceQuestionOverrideFormSettings: PracticeQuestionOverrideFormSettings;
  onChangeToggle: (value) => void;
}) {
  const [displayWarning, setDisplayWarning] = useState(false);

  const handleToggleChange = (value: boolean) => {
    if (!value) {
      setDisplayWarning(true);
    } else {
      onChangeToggle(true);
    }
  };
  return (
    <>
      {practiceQuestionOverrideFormSettings.updatePracticeQuestionOverrideUrl && (
        <div className="no-label-field-groups toggle">
          <h3 className="title">
            {isDmipPlatform &&
              i18n[
                "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.PracticeAndDoctors.Toggle.Title"
              ]}
            {!isDmipPlatform &&
              i18n[
                "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.Doctors.Toggle.Title"
              ]}
          </h3>
          <ToggleButton
            id={"pracite-question-override-toggle"}
            value={practiceQuestionOverrideFormSettings.practiceQuestionOverride}
            onChange={handleToggleChange}
          />
          {displayWarning && (
            <ModalWarning
              action={async () => {
                setDisplayWarning(false);
                onChangeToggle(false);
              }}
              cancel={() => setDisplayWarning(false)}
              title={
                i18n[
                  "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.DisableModal.Title"
                ]
              }
              actionButtonLabel={
                i18n[
                  "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.DisableModal.Disable"
                ]
              }
            >
              <p>
                {
                  i18n[
                    "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.DisableModal.Content"
                  ]
                }
              </p>
            </ModalWarning>
          )}
        </div>
      )}
    </>
  );
}
